export default "__VITE_ASSET__5843e882__"